import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { routeTracker } from '@/lib/route-tracker';

export function useRouteTracking(isAuthenticated: boolean) {
    const location = useLocation();
    const params = useParams();

    useEffect(() => {
        if (isAuthenticated) {
            routeTracker.start();
            return () => {
                routeTracker.flush();
                routeTracker.stop();
            };
        }
    }, [isAuthenticated]);

    useEffect(() => {
        if (isAuthenticated) {
            routeTracker.trackNavigation(location.pathname, params);
        }
    }, [location.pathname, params, isAuthenticated]);
}
